import { getCurrentUser } from '@bridebook/toolbox/src/api/auth/getCurrentUser';

/**
 * `fetch` implementation for an AI SDK `DefaultChatTransport`, carrying the current user's Firebase
 * bearer token.
 *
 * Chat routes stream SSE and the transport wants the raw `Response`, so these calls cannot go through
 * `fetchy()` — it resolves every request via `response.json()`. Plain request/response endpoints still
 * use `fetchy()` as usual.
 *
 * `init` is passed through untouched apart from the added header, so a caller can still rewrite the body.
 */
export const chatTransportFetch = async (
  input: RequestInfo | URL,
  init?: RequestInit,
): Promise<Response> => {
  const user = await getCurrentUser();
  const token = user ? await user.getIdToken() : null;
  const headers = new Headers(init?.headers);
  if (token) headers.set('Authorization', `Bearer ${token}`);
  return fetch(input, { ...init, headers });
};
